import { Token } from 'config/types'
import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import { useNetwork } from 'state/app/hooks'
import theme from 'theme'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { PaymentChevronRightIcon, PaymentInputContainer } from './styles'

export const CurrencyDisplayInfo: React.FC<{
  token: Token
  hideNetwork?: boolean
}> = ({ token, hideNetwork }) => {
  const network = useNetwork(token?.network)
  return (
    <RowMiddle gap="8px">
      <Text color="var(--pm-color)" small fontWeight={600} letterSpacing={-0.28}>
        {token.name}
      </Text>
      {network?.network?.networkInfo?.displayName && !hideNetwork && (
        <Text
          style={{
            padding: '4px 8px',
            borderRadius: 'var(--pm-trigger-radius)',
            background: theme.colors.backgroundAlt19,
          }}
          fontSize="12px"
          color="var(--pm-label-color)"
          bold
          letterSpacing={'-0.43px'}
          ellipsis={1}
        >
          {network?.network?.networkInfo?.displayName}
        </Text>
      )}
    </RowMiddle>
  )
}

const SelectedCurrencyItem: React.FC<{
  selectedToken: Token
  onPresentSelectCurrency?: () => void
  disabled?: boolean
  hideNetwork?: boolean
  placeholder?: string
}> = ({ selectedToken, hideNetwork = true, onPresentSelectCurrency, disabled, placeholder }) => {
  return (
    <PaymentInputContainer p="12px" onClick={() => !disabled && onPresentSelectCurrency && onPresentSelectCurrency()}>
      {selectedToken ? (
        <RowMiddle flex={1} gap="8px">
          <TokenLogo token={selectedToken} size={20} hideNetwork={hideNetwork} />
          <CurrencyDisplayInfo token={selectedToken} hideNetwork={hideNetwork} />
        </RowMiddle>
      ) : (
        <RowMiddle flex={1} gap="8px">
          <Text small color="var(--pm-label-color)">
            <Trans>{placeholder || 'Choose Token'}</Trans>
          </Text>
        </RowMiddle>
      )}

      {!disabled && onPresentSelectCurrency && (
        <RowMiddle width={12}>
          <PaymentChevronRightIcon />
        </RowMiddle>
      )}
    </PaymentInputContainer>
  )
}

export default SelectedCurrencyItem
